import React from "react";
import { Puff } from "react-loader-spinner";
import "./PuffLoader.css"; // Import the CSS file
const PuffLoader = () => {
  return (
    <div>
      <Puff
        visible={true}
        height="80"
        width="80"
        color="#c0c0c0"
        radius="9"
        ariaLabel="puff-loading"
        wrapperStyle={{}}
        wrapperClass=""
      />
    </div>
  );
};

export default PuffLoader;
